import axios from '@/utils/request'
import {
  getLocalStorage
} from '@/utils/auth'

const http = {

  /** get 请求
   * @param  {接口地址} url
   * @param  {请求参数} params
   */
  get: function (url, params = {}) {
    let envCode = getLocalStorage('envCode') ? getLocalStorage('envCode') : '0'
    let baseURL = getLocalStorage('envJson') ? JSON.parse(getLocalStorage('envJson'))[envCode].customerPath + 'prod-api' : '';
    const config = {
      baseURL: envCode ? baseURL : ''
    }
    // 如果是本地开发服务启动 (npm run dev)，或者 envJson 中只有一个环境配置
    if (process.env.VUE_APP_IS_SERVE === 'true') {
      config.baseURL = process.env.VUE_APP_PROXY_URL
    }
    return new Promise((resolve, reject) => {
      axios(config).get(url, {
        params: axios(config).adornParams(params)
      })
        .then((response) => {
          const data = response
          if (data.code === 0) {
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /** post 请求
   * @param  {接口地址} url
   * @param  {请求参数} params
   */
  post: function (url, params = {}, option) {
    let envCode = getLocalStorage('envCode') ? getLocalStorage('envCode') : '0'
    let baseURL = getLocalStorage('envJson') ? JSON.parse(getLocalStorage('envJson'))[envCode].screenPath : '';
    const config = {
      baseURL: envCode ? baseURL : ''
    }
    // 如果是本地开发服务启动 (npm run dev)，或者 envJson 中只有一个环境配置
    if (process.env.VUE_APP_IS_SERVE === 'true') {
      config.baseURL = process.env.VUE_APP_PROXY_URL
    }
    return new Promise((resolve, reject) => {
      if (option) console.log('optionoptionoption', option);
      axios(config).post(url, axios(config).adornData(params), option)
        .then((response) => {
          const data = response
          if (data instanceof Blob) {
            console.log('data instanceof Blob', data);
          }
          if (data.code === 0 || data instanceof Blob) {
            try {
              // console.log(url, JSON.parse(data.data))
            } catch (error) {
              console.log(url, error)
            }
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch((error) => {
          console.log('errorerrorerrorerror', error);
          reject(error)
        })
    })
  }
}
export default http
